import { render, staticRenderFns } from "./snPhoneInput.vue?vue&type=template&id=6e8e47d6&scoped=true&"
import script from "./snPhoneInput.vue?vue&type=script&lang=js&"
export * from "./snPhoneInput.vue?vue&type=script&lang=js&"
import style0 from "./snPhoneInput.vue?vue&type=style&index=0&id=6e8e47d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8e47d6",
  null
  
)

export default component.exports